import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getAirportConditionsbyState(state) {
  try {
    const res = await tryCache(`getAirportConditionsbyState-${Cookies.get('state')}`, () =>
      apiClient.post('/getAirportConditionsbyState', {
        state: Cookies.get('state'),
      }),
    );
    return res;
  } catch (error) {
    console.error('getAirportConditionsbyState failed.', error);
  }
}

export async function getAirportDelays() {
  try {
    const res = await tryCache(
      `getAirportDelays-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/getAirportDelayForecast', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          latitude: Cookies.get('latitude'),
          longitude: Cookies.get('longitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getAirportDelayForecast failed.', error);
  }
}
